export default 
[
  {
    id: -1,
    nome: ''
  },
  {
    id: 0,
    nome: 'Conta Corrente'
  },
  {
    id: 1,
    nome: 'Conta Poupança'
  },
  {
    id: 2,
    nome: 'Conta Salário'
  },
]



// WEBPACK FOOTER //
// ./FrontEnd/js/tipos-conta.js